import { render, staticRenderFns } from "./ImageManagement.vue?vue&type=template&id=11c8a77b"
import script from "./ImageManagement.vue?vue&type=script&lang=js"
export * from "./ImageManagement.vue?vue&type=script&lang=js"
import style0 from "./ImageManagement.vue?vue&type=style&index=0&id=11c8a77b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports